import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const WITHOUT = ['Entrenas sin plan', 'Te fundes al final', 'Corners a la suerte', 'Lesiones recurrentes', 'Sin medir progreso'];
const WITH = ['Método por niveles', 'Físico específico', 'Playbook de corners', 'Prevención real', 'Tests + planillas'];
export function Comparison() {
  return <section className="px-4 py-8" data-id="element-81" data-mp="1ux7eubrkq2pm">
      <h2 className="mb-5 text-center font-display text-2xl leading-tight text-white" data-id="element-82" data-mp="1uw5pr3dq3fow">
        Sin Hockey Pro System <span className="text-white/40" data-id="element-83" data-mp="1zuz571cklgrp">vs</span> Con Hockey Pro System
      </h2>

      <div className="grid grid-cols-2 gap-3" data-id="element-84" data-mp="23xngrgso51sd">
        {/* Without */}
        <div className="rounded-2xl border border-white/10 bg-hockey-card p-3" data-id="element-85" data-mp="28wzy5m0rtgnk">
          <p className="mb-3 text-center text-[13px] font-extrabold uppercase tracking-wide text-white/60" data-id="element-86" data-mp="28uvvt8iisppe">
            Sin el sistema
          </p>
          <ul className="space-y-2.5" data-id="element-87" data-mp="ei5w2a5h0ma3">
            {WITHOUT.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-88" data-mp="1m0h0emgkmg5e">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-89" data-mp="1m2tozigu3orf" />
                <span className="text-[13px] leading-snug text-white/70" data-id="element-90" data-mp="1h97cbqao7kvm">{t}</span>
              </li>)}
          </ul>
        </div>

        {/* With */}
        <div className="rounded-2xl border-2 border-hockey-pink bg-hockey-pink/10 p-3" data-id="element-91" data-mp="189uanjssg0lg">
          <p className="mb-3 text-center text-[13px] font-extrabold uppercase tracking-wide text-hockey-pink" data-id="element-92" data-mp="24zbedt87ncki">
            Con el sistema
          </p>
          <ul className="space-y-2.5" data-id="element-93" data-mp="20yhoiub7jnoz">
            {WITH.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-94" data-mp="1vy3pg1rl3o33">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" data-id="element-95" data-mp="1qzsh5vgxtlmz" />
                <span className="text-[13px] font-semibold leading-snug text-white" data-id="element-96" data-mp="1r1wn0iyecupw">{t}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}